import React from "react";
import { Box, Chip, Skeleton, Typography } from "@mui/material";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AIDisclaimer from "../common/AIDisclaimer";

export default function AISummary({ summary, isRefreshing, hasData = true }) {
    const showSkeleton = !summary && isRefreshing;

    return (
        <Box
            sx={{
                borderRadius: 2,
                bgcolor: "background.paper",
                p: 2.5,
                boxShadow: 1,
                width: "100%"
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1.5,
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AutoAwesomeOutlinedIcon sx={{ fontSize: 20, color: "#0E8B63" }} />
                    <Typography variant="h6" fontWeight={600} sx={{ color: "#154C3A" }}>
                        AI Well-Being Overview
                    </Typography>
                </Box>

                {isRefreshing && (
                    <Chip
                        size="small"
                        label="Updating..."
                        color="primary"
                        variant="outlined"
                    />
                )}
            </Box>

            {showSkeleton ? (
                <>
                    <Skeleton variant="text" />
                    <Skeleton variant="text" />
                    <Skeleton variant="text" width="80%" />
                </>
            ) : !hasData ? (
                <Box
                    sx={{
                        minHeight: 100,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "text.secondary",
                        fontSize: "0.9rem",
                        opacity: 0.8,
                    }}
                >
                    No assessment data available for the selected filters.
                </Box>
            ) : (
                <>
                    <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-line", lineHeight: 1.6 }}>
                        {summary || "No AI overview available yet."}
                    </Typography>

                    {summary && (
                        <AIDisclaimer
                            variant="banner"
                            title="AI Wellbeing Insights Disclaimer"
                            text="This summary is generated by AI to highlight organizational wellness patterns. It is intended for trend exploration and does not constitute clinical or medical advice."
                            sx={{ mt: 2 }}
                        />
                    )}
                </>
            )}
        </Box>
    );
}
